import type { MutableRefObject } from "react";

import type { CommandScope } from "src/components/commandbar/types";

// Reads the scope a control asked the next open to start in, and clears it so later opens start unscoped.
export const takeInitialScope = (
  ref: MutableRefObject<CommandScope | null>,
): CommandScope | null => {
  const scope = ref.current;
  ref.current = null;
  return scope;
};
